import { axiosInstance, strapiClient } from "@/config/axios-wrapper";
import { V2Response } from "@/types/api";
import {
  SubscriptionFeaturesLeft,
  SubscriptionPlan,
  SubscriptionPlanTrialStatus,
} from "@/types/subscription";
import { normalizeSubscriptionPlan } from "@/utils/subscription";


export const getSubscriptionTrialStatus = async (organizationId: string) => {
  const response = await axiosInstance.get<V2Response<SubscriptionPlanTrialStatus>>(
    `/organizations/${organizationId}/trialStatus`,
  );
  return response.data.result;
};

export const getSubscriptionFeaturesLeftDetails = async (organizationId: string) => {
  const response = await axiosInstance.get<V2Response<SubscriptionFeaturesLeft>>(
    `/organizations/${organizationId}/featuresLeft`,
  );
  return response.data.result;
};

export const getSubscriptionDetails = async (organizationId: string) => {
  const response = await axiosInstance.get<V2Response<SubscriptionPlan>>(
    `/organizations/${organizationId}/subscription`,
  );
  return normalizeSubscriptionPlan(response.data.result);
};

export const subscribeToNewsletter = async (data: { Email: string }) => {
  const response = await strapiClient.post(`/subscribers`, { data });
  return response.data;
};
